import { render, staticRenderFns } from "./GrmMenu.vue?vue&type=template&id=f0423496&scoped=true&"
import script from "./GrmMenu.vue?vue&type=script&lang=js&"
export * from "./GrmMenu.vue?vue&type=script&lang=js&"
import style0 from "./GrmMenu.vue?vue&type=style&index=0&id=f0423496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0423496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0423496')) {
      api.createRecord('f0423496', component.options)
    } else {
      api.reload('f0423496', component.options)
    }
    module.hot.accept("./GrmMenu.vue?vue&type=template&id=f0423496&scoped=true&", function () {
      api.rerender('f0423496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/menu/GrmMenu.vue"
export default component.exports